define('services/tabmanager',['require'],function(require) {		
	function CreateTabManager($tabAnchors, AnchorHrefsAndLoadFuncs) {
		var TabManager = {
			$tabAnchors: $tabAnchors,
			AnchorHrefsAndLoadFuncs: AnchorHrefsAndLoadFuncs,
			init: function () {
				for (var i = TabManager.AnchorHrefsAndLoadFuncs.length - 1; i >= 0; i--) {
					var AnchorHrefAndLoadFunc = TabManager.AnchorHrefsAndLoadFuncs[i];
					AnchorHrefAndLoadFunc.Loaded = false;
				}

				//handle click
				$tabAnchors.on("click", function (e) {
					e.preventDefault();
					var $this = $(this),
						Href = $this.attr("href");

					$this.tab('show');
					TabManager.LoadTab(Href);
				});
			},
			LoadTab: function (Href) {
				for (var i = TabManager.AnchorHrefsAndLoadFuncs.length - 1; i >= 0; i--) {
					var AnchorHrefAndLoadFunc = TabManager.AnchorHrefsAndLoadFuncs[i];
					if (!AnchorHrefAndLoadFunc.Loaded && AnchorHrefAndLoadFunc.Href == Href) { //only reload tab data, if it hasn't been loaded in
						AnchorHrefAndLoadFunc.Func.call();
						AnchorHrefAndLoadFunc.Loaded = true;
						break;
					}
				}
			},
			Unload: function () {
				var selectors = [];
				for (var i = TabManager.AnchorHrefsAndLoadFuncs.length - 1; i >= 0; i--) {
					var AnchorHrefAndLoadFunc = TabManager.AnchorHrefsAndLoadFuncs[i];
					AnchorHrefAndLoadFunc.Loaded = false;

					if (AnchorHrefAndLoadFunc.Unload == undefined) {
						selectors.push(AnchorHrefAndLoadFunc.Href);
					} else {
						AnchorHrefAndLoadFunc.Unload.call();
					}
				}
				$(selectors.join(",")).html("");
			}
		};
		return TabManager;
	}
	return CreateTabManager;
});
